import api from '@/services/api'

export default {
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    user: {
      id: 0,
      clientId: 0,
      clientTypePerson: 0,
      roleId: 0,
      name: '',
      isAdmin: 0,
    },
  },

  mutations: {
    AUTH(state, user) {
      state.isLoggedIn = true
      state.user = {
        id: Number(user.id),
        clientId: Number(user.clientId),
        clientTypePerson: Number(user.clientTypePerson),
        roleId: user.roleId,
        name: user.name,
        isAdmin: Number(user.isAdmin),
      }
    },

    LOGOUT(state) {
      state.isLoggedIn = false
      state.user = {
        id: 0,
        clientId: 0,
        clientTypePerson: 0,
        roleId: 0,
        name: '',
        isAdmin: 0,
      }
    },

    SET_NAME_USER(state, payload) {
      state.user.name = payload
    },
  },

  actions: {
    async auth({ commit }, credentials) {
      try {
        const response = await api.post('/auth/login', {
          login: credentials.login,
          password: credentials.password,
        })

        const data = response && response.data ? response.data : null
        const token = data && data.token ? data.token : ''

        const user = {
          id: data && data.user ? data.user.id : 0,
          clientId: data && data.user ? data.user.clientId : 0,
          clientTypePerson: data && data.user ? data.user.clientTypePerson : 0,
          roleId: data && data.user ? data.user.roleId : 0,
          name: data && data.user ? data.user.name : '',
          isAdmin: data && data.user ? data.user.isAdmin : false,
        }

        localStorage.setItem('token', token)
        commit('AUTH', user)
      } catch (error) {
        commit('LOGOUT')
        throw error
      }
    },

    async passwordRecovery({ commit }, email) {
      try {
        const response = await api.post('/auth/password/recovery', {
          email,
        })

        return response || null
      } catch (error) {
        throw error
      }
    },

    async newPassword({ commit }, data) {
      try {
        const response = await api.post('/auth/password/new', data)

        return response || null
      } catch (error) {
        throw error
      }
    },

    logout: ({ commit }) => {
      commit('LOGOUT')
    },

    setNameUser: ({ commit }, name) => {
      commit('SET_NAME_USER', name)
    },
  },

  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    user: (state) => state.user,
  },
}
